
import { Form, TextField } from "../util";
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import hash from "object-hash";

import { ClinicBody } from "@/domain/params";
import { clinicService } from "@/domain/services";

type ComponentData = {
  clinic_id?: number;
  isLoading: boolean;
  field_valid: { [field: string]: boolean };
  body: ClinicBody;
  body_hash?: string;
};

export default defineComponent({
  name: "ClinicForm",
  components: { Form, TextField },
  data(): ComponentData {
    const clinic_id = Number(this.$route.params.clinic_id);
    return {
      clinic_id,
      isLoading: false,
      field_valid: {
        name: !!clinic_id,
        phone: !!clinic_id,
        cnpj: !!clinic_id,
        address: !!clinic_id,
      },
      body: { name: "", phone: "", cnpj: "", address: "" },
    };
  },
  created() {
    if (this.clinic_id) this.loadClinic(this.clinic_id);
  },
  computed: {
    isFormValid() {
      for (let field_name in this.field_valid)
        if (!this.field_valid[field_name]) return false;
      return true;
    },
  },
  methods: {
    loadClinic(clinic_id: number) {
      this.isLoading = true;
      clinicService
        .getById(clinic_id)
        .then((clinic) => {
          this.isLoading = false;
          this.body = {
            name: clinic.name,
            phone: clinic.phone.maskPhone(),
            cnpj: clinic.cnpj.maskCnpj(),
            address: clinic.address,
            latitude: clinic.latitude,
            longitude: clinic.longitude
          };
          this.body_hash = hash(this.body);
        })
        .catch(() => {
          this.$router.push("/clinics");
        });
    },
    save() {
      this.isLoading = true;
      const payload = {
        ...this.body,
        phone: this.body.phone.removeMask(),
        cnpj: this.body.cnpj.removeMask(),
      };

      if (this.clinic_id && this.body_hash != hash(this.body)) {
        return clinicService
          .update(this.clinic_id, payload)
          .then(() => {
            this.reloadClinics();
            this.$router.push("/clinics");
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else if (!this.clinic_id)
        return clinicService
          .create(payload)
          .then(() => {
            this.reloadClinics();
            this.$router.push("/clinics");
          })
          .catch(() => {
            this.isLoading = false;
          });
      this.$router.push("/clinics");
    },
    closeModal(e: Event) {
      if (
        e.target == this.$refs.modal_mask ||
        e.target == this.$refs.close_modal
      )
        this.$router.push("/clinics");
    },
    updateValidation(field: string, valid: boolean) {
      this.field_valid[field] = valid;
    },
    ...mapActions({ reloadClinics: "clinics/load" }),
  },
});
